import { Button, Grid } from '@material-ui/core'
import MultiSelect from '../../../control/multiSelect/multiSelect'
import { makeStyles } from '@material-ui/styles'
import { FC } from 'react'
import { Form as FinalForm } from 'react-final-form'
import MyTextfield from '../../../control/textfield/textfield'
import useTranslate from '../../../i18n/useTranslate'

import useProjectStatus from '../../../services/um/lookups/useProjectStatus'
import { ConsiderationFormType } from '../../../services/um/useSettingConsideration'
import { useHistory, useParams } from 'react-router-dom'
import { RoutePath } from '../../../router/routesConfig'
import Select from '../../../control/select/select'

export type FormType = {
    nameTH: string | null
    nameEN: string | null
    submittedTypeID: string[]
    weekNumber: number | null
}
interface FormProps {
    onBack: () => void
    initialValues: any
    onSubmit: (values: ConsiderationFormType) => void
}
const Form: FC<FormProps> = ({ onBack, initialValues, onSubmit }) => {
    const { projectStatus } = useProjectStatus()
    const classes = useStyle()
    const translate = useTranslate()
    const defaultSelect = initialValues?.submittedTypeID.map(String)
    const params = useParams<{ id: string }>()
    return (
        <FinalForm onSubmit={onSubmit} initialValues={initialValues}>
            {({ handleSubmit }) => {
                return (
                    <div>
                        <Grid container spacing={2} className={classes.container}>
                            <Grid item xs={12} sm={12} md={6}>
                                <MyTextfield
                                    name="nameTH"
                                    materialInputProps={{
                                        label: `${translate.get('UM.SETTING_CONSIDERATION.NAME_TH')}`,
                                        disabled: false,
                                        placeholder: `${translate.get('UM.SETTING_CONSIDERATION.NAME_TH')}`,
                                        size: 'small',
                                    }}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}>
                                <MyTextfield
                                    required
                                    name="nameEN"
                                    materialInputProps={{
                                        label: `${translate.get('UM.SETTING_CONSIDERATION.NAME_EN')}`,
                                        disabled: false,
                                        placeholder: `${translate.get('UM.SETTING_CONSIDERATION.NAME_EN')}`,
                                        size: 'small',
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}>
                                <MyTextfield
                                    name="weekNumber"
                                    materialInputProps={{
                                        label: `${translate.get('UM.SETTING_CONSIDERATION.DURATION')}`,
                                        disabled: false,
                                        placeholder: `${translate.get('UM.SETTING_CONSIDERATION.DURATION')}`,
                                        size: 'small',
                                    }}
                                    type="number"
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}>
                                <MultiSelect
                                    name="submittedTypeID"
                                    option={projectStatus}
                                    label={translate.get('UM.SETTING_CONSIDERATION.SUBMITTED_TYPE')}
                                    placeholder={translate.get('UM.SETTING_CONSIDERATION.SUBMITTED_TYPE')}
                                    size="small"
                                    defaultValue={defaultSelect}
                                    required
                                    disabled={params.id ? true : false}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container justify="flex-end" spacing={2}>
                                    <Grid item>
                                        <Button
                                            size={'large'}
                                            variant="contained"
                                            className={classes.cancelButton}
                                            onClick={onBack}
                                        >
                                            {translate.get('BUTTON.CANCEL')}
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            size={'large'}
                                            variant="contained"
                                            color="primary"
                                            onClick={handleSubmit}
                                            className={classes.saveButton}
                                            style={{ minWidth: '0px' }}
                                        >
                                            {translate.get('BUTTON.SAVE')}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                )
            }}
        </FinalForm>
    )
}

const useStyle = makeStyles(() => ({
    container: {
        width: '100%',
    },
    reset: {
        textDecoration: 'underline',
        cursor: 'pointer',
        padding: '0px 1.5rem',
        alignSelf: 'center',
    },
    root: {
        width: '100%',
        height: '100%',
        padding: '1rem 0px',
    },
    cancelButton: {
        backgroundColor: '#FFFFFF',
        border: 'solid 1px #db5f8e',
    },
    saveButton: {
        border: 'solid 1px #db5f8e',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    },
}))

export default Form
